import { useEffect, useState } from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import {
  HomeIcon,
  UsersIcon,
  ReceiptIcon,
  WalletIcon,
  AlertIcon,
  ShieldIcon,
  SunIcon,
  MoonIcon
} from "./icons";
import stucredLogo from "../assets/StuCred_Logo.png";

const NAV_ITEMS = [
  { to: "/", label: "Overview", icon: HomeIcon, end: true },
  { to: "/users", label: "Registrations", icon: UsersIcon },
  { to: "/transactions", label: "Transactions", icon: ReceiptIcon },
  { to: "/loans", label: "Loans", icon: WalletIcon },
  { to: "/dpd", label: "Presentation", icon: AlertIcon },
  { to: "/uv", label: "UV", icon: ShieldIcon }
];

function getInitialTheme() {
  if (typeof document === "undefined") return "light";
  return document.documentElement.getAttribute("data-theme") || "light";
}

export default function Layout() {
  const location = useLocation();
  const [theme, setTheme] = useState(getInitialTheme);

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    try {
      localStorage.setItem("sc-theme", theme);
    } catch (e) {
      /* ignore */
    }
  }, [theme]);

  const toggleTheme = () => setTheme((t) => (t === "dark" ? "light" : "dark"));

  const handleLogoClick = (e) => {
    e.preventDefault();
    if (location.pathname === "/") {
      window.location.reload();
    } else {
      window.location.href = "/";
    }
  };

  const activeIndex = NAV_ITEMS.findIndex((item) =>
    item.end ? location.pathname === item.to : location.pathname.startsWith(item.to)
  );

  return (
    <div className="app-shell">
      {/* Sticky Full-Width Top Navbar */}
      <header className="app-navbar">
        <div className="app-navbar__inner">
          <div className="app-navbar__left">
            {/* Brand Logo Button with Official Logo Asset: Refreshes when clicked */}
            <a
              href="/"
              onClick={handleLogoClick}
              className="brand-logo-btn"
              title="StuCred — Click to refresh"
            >
              <img src={stucredLogo} alt="StuCred Logo" className="brand-logo-img" />
              <span className="brand-logo-text">StuCred</span>
            </a>
          </div>

          {/* Centered Capsule Navigation Tabs */}
          <nav
            className="nav-capsule"
            style={{ "--count": NAV_ITEMS.length, "--nav-i": Math.max(activeIndex, 0) }}
          >
            <div className={`nav-capsule__indicator${activeIndex < 0 ? " hidden" : ""}`} aria-hidden="true" />
            {NAV_ITEMS.map(({ to, label, icon: Icon, end }) => (
              <NavLink
                key={to}
                to={to}
                end={end}
                className={({ isActive }) => `nav-capsule__link${isActive ? " active" : ""}`}
              >
                <Icon />
                <span>{label}</span>
              </NavLink>
            ))}
          </nav>

          {/* Right Action Controls: Darkmode Alone */}
          <div className="app-navbar__right">
            <button
              type="button"
              className="navbar-icon-btn"
              onClick={toggleTheme}
              aria-label={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
              title={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
            >
              {theme === "dark" ? <SunIcon /> : <MoonIcon />}
            </button>
          </div>
        </div>
      </header>

      {/* Main Full-Page Routed Content */}
      <main className="main-content page-transition" key={location.pathname}>
        <Outlet />
      </main>
    </div>
  );
}
